module.exports = __webpack_public_path__ + "static/media/feature_icon_3.94b0f4a0.png";